import axios from '../axios-data'
import {v4 as uuidv4} from 'uuid';

let customerList = [];
let transactionId = 0;

export const consumerConsents = () => {
    customerList = [];
    const applicantData = (customer) => {
        const customerInfo = createCustomerInfo(customer);
        customerList.push(customerInfo);
    };

    const postConsentData = async (config) => {
        const data = {
            metadata: {
                source: "Enroll",
                transactionId: transactionId === 0 ? uuidv4() : transactionId,
                timeStamp: new Date()
            },
            consumers: customerList
        };
        transactionId = data.metadata.transactionId;

        try {
            const baseURL = config.cnrApiUrl;
            const suffix = '/cnr/v1/consents';
            const fullURL = `${baseURL}${suffix}`;

            await axios.post(fullURL, data);

        } catch (error) {
            console.error('Error posting consent data:', error);
        }

    };

    return {
        applicantData,
        postConsentData
    };
};

const createCustomerInfo = (customer) => {
    const customerInfo = {
        firstName: customer.firstName,
        lastName: customer.lastName,
        ssn: customer.ssn,
        email: [emailConsent(customer)],
        consents: otherConsents(customer)
    };

    // Since phone is optional, make sure to add it in if the user submitted it
    if(customer?.mobile) {
        customerInfo.phone = [phoneConsent(customer)]
    }

    return customerInfo;
};

export const otherConsents = (customer) => {
    return {
        electronic: !!customer?.esignDisclosure,
        credit: !!customer?.esignDisclosure,
    };
};

export const emailConsent = (customer) => {
    return {
        type: "email",
        emailId: customer?.email,
        consents: {
            marketing: {
                email: !!customer?.edeliveryDisclosure
            },
            servicing: {
                email: !!customer?.edeliveryDisclosure
            }
        }
    }
};

export const phoneConsent = (customer) => {
	return {
		type: "Mobile Phone",
        phoneNumber: customer?.mobile.replace(/\D/g, ''),
		consents: {
            marketing: {
                sms: !!customer?.TCPADisclosure,
                voice: !!customer?.TCPADisclosure,
            },
			servicing: {
                sms: !!customer?.TCPADisclosure,
                voice: !!customer?.TCPADisclosure,
			}
		}
	}
};
